import script from "./search-page-results.vue?vue&type=script&setup=true&lang=js"
export * from "./search-page-results.vue?vue&type=script&setup=true&lang=js"

import "./search-page-results.vue?vue&type=style&index=0&id=e1438a90&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1438a90"]])

export default __exports__